import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-center text-[#10b981] my-8 px-5"
}
const _hoisted_2 = { class: "mt-0 lg:px-5" }
const _hoisted_3 = { class: "mt-3 lg:px-5" }
const _hoisted_4 = { class: "mt-3 lg:px-5" }
const _hoisted_5 = { class: "mt-3 lg:px-5" }
const _hoisted_6 = {
  key: 0,
  class: "mt-3 lg:px-5"
}
const _hoisted_7 = {
  key: 1,
  class: "mt-3 lg:px-5"
}
const _hoisted_8 = { class: "mt-3 lg:px-5" }
const _hoisted_9 = {
  key: 2,
  class: "mt-3"
}
const _hoisted_10 = { class: "flex flex-col gap-1 items-center mt-3" }
const _hoisted_11 = { class: "relative z-0 grid justify-center items-center w-[200px] h-[75px] mt-3 mx-auto rounded-md border-2 border-gray-200 overflow-hidden!" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "flex flex-col gap-1 items-center mt-3" }

export function render(_ctx, _cache) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_IftaLabel = _resolveComponent("IftaLabel")
  const _component_Message = _resolveComponent("Message")
  const _component_Password = _resolveComponent("Password")
  const _component_Select = _resolveComponent("Select")
  const _component_InputOtp = _resolveComponent("InputOtp")
  const _component_Button = _resolveComponent("Button")
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")
  const _component_Divider = _resolveComponent("Divider")
  const _component_Toast = _resolveComponent("Toast")
  const _directive_keyfilter = _resolveDirective("keyfilter")

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[23] || (_cache[23] = _createElementVNode("h1", { class: "text-3xl text-[#10b981] my-5" }, "สมัครสมาชิก", -1 /* HOISTED */)),
    (!_ctx.registerEnabled)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[10] || (_cache[10] = [
          _createElementVNode("p", { class: "text-lg font-semibold" }, "ปิดรับสมัครสมาชิกชั่วคราว", -1 /* HOISTED */),
          _createElementVNode("p", { class: "text-sm mt-2 opacity-80" }, "กรุณาติดต่อแอดมินเพื่อสอบถามเพิ่มเติม", -1 /* HOISTED */)
        ])))
      : (_openBlock(), _createElementBlock("form", {
          key: 1,
          onSubmit: _cache[9] || (_cache[9] = _withModifiers((...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_IftaLabel, null, {
              default: _withCtx(() => [
                _withDirectives(_createVNode(_component_InputText, {
                  id: "register_phone",
                  modelValue: _ctx.form.phone.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.form.phone.value) = $event)),
                  onKeyup: _ctx.checkPhoneNumber,
                  inputmode: "tel",
                  maxlength: "10",
                  invalid: _ctx.form.phone.invalid,
                  class: "w-full text-white! bg-[url('https://rpg168-storage.sgp1.cdn.digitaloceanspaces.com/theme/bg-input-1.webp')]! bg-size-[100%_100%]! bg-transparent! border-0!",
                  autofocus: "",
                  "aria-autocomplete": "none"
                }, null, 8 /* PROPS */, ["modelValue", "onKeyup", "invalid"]), [
                  [
                    _directive_keyfilter,
                    void 0,
                    void 0,
                    { int: true }
                  ]
                ]),
                _cache[11] || (_cache[11] = _createElementVNode("label", {
                  for: "register_phone",
                  class: "text-white! text-[0.8rem]! font-semibold!"
                }, "เบอร์โทรศัพท์", -1 /* HOISTED */))
              ]),
              _: 1 /* STABLE */,
              __: [11]
            }),
            (_ctx.form.phone.invalid)
              ? (_openBlock(), _createBlock(_component_Message, {
                  key: 0,
                  size: "small",
                  severity: "secondary",
                  variant: "simple",
                  class: "text-red-700! ml-2 mt-0.5",
                  pt: { text: 'text-[11px]!' }
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.form.phone.msgErr), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_IftaLabel, null, {
              default: _withCtx(() => [
                _createVNode(_component_Password, {
                  id: "register_password",
                  modelValue: _ctx.form.password.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.form.password.value) = $event)),
                  onKeyup: _ctx.checkPassword,
                  class: "w-full",
                  "input-class": "w-full text-white! bg-[url('https://rpg168-storage.sgp1.cdn.digitaloceanspaces.com/theme/bg-input-1.webp')]! bg-size-[100%_100%]! bg-transparent! border-0!",
                  invalid: _ctx.form.password.invalid,
                  toggleMask: "",
                  feedback: false,
                  "aria-autocomplete": "none"
                }, null, 8 /* PROPS */, ["modelValue", "onKeyup", "invalid"]),
                _cache[12] || (_cache[12] = _createElementVNode("label", {
                  for: "register_password",
                  class: "text-white! text-[0.8rem]! font-semibold!"
                }, "รหัสผ่าน", -1 /* HOISTED */))
              ]),
              _: 1 /* STABLE */,
              __: [12]
            }),
            (_ctx.form.password.invalid)
              ? (_openBlock(), _createBlock(_component_Message, {
                  key: 0,
                  size: "small",
                  severity: "secondary",
                  variant: "simple",
                  class: "text-red-700! ml-2 mt-0.5",
                  pt: { text: 'text-[11px]!' }
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.form.password.msgErr), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_IftaLabel, null, {
              default: _withCtx(() => [
                _createVNode(_component_InputText, {
                  id: "first_name",
                  modelValue: _ctx.form.firstName.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.form.firstName.value) = $event)),
                  inputmode: "text",
                  invalid: _ctx.form.firstName.invalid,
                  class: "w-full text-white! bg-[url('https://rpg168-storage.sgp1.cdn.digitaloceanspaces.com/theme/bg-input-1.webp')]! bg-size-[100%_100%]! bg-transparent! border-0!",
                  autofocus: "",
                  "aria-autocomplete": "none"
                }, null, 8 /* PROPS */, ["modelValue", "invalid"]),
                _cache[13] || (_cache[13] = _createElementVNode("label", {
                  for: "first_name",
                  class: "text-white! text-[0.8rem]! font-semibold!"
                }, "ชื่อ", -1 /* HOISTED */))
              ]),
              _: 1 /* STABLE */,
              __: [13]
            }),
            (_ctx.form.firstName.invalid)
              ? (_openBlock(), _createBlock(_component_Message, {
                  key: 0,
                  size: "small",
                  severity: "secondary",
                  variant: "simple",
                  class: "text-red-700! ml-2 mt-0.5",
                  pt: { text: 'text-[11px]!' }
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.form.firstName.msgErr), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_IftaLabel, null, {
              default: _withCtx(() => [
                _createVNode(_component_InputText, {
                  id: "last_name",
                  modelValue: _ctx.form.lastName.value,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.form.lastName.value) = $event)),
                  inputmode: "text",
                  invalid: _ctx.form.lastName.invalid,
                  class: "w-full text-white! bg-[url('https://rpg168-storage.sgp1.cdn.digitaloceanspaces.com/theme/bg-input-1.webp')]! bg-size-[100%_100%]! bg-transparent! border-0!",
                  autofocus: "",
                  "aria-autocomplete": "none"
                }, null, 8 /* PROPS */, ["modelValue", "invalid"]),
                _cache[14] || (_cache[14] = _createElementVNode("label", {
                  for: "last_name",
                  class: "text-white! text-[0.8rem]! font-semibold!"
                }, "นามสกุล", -1 /* HOISTED */))
              ]),
              _: 1 /* STABLE */,
              __: [14]
            }),
            (_ctx.form.lastName.invalid)
              ? (_openBlock(), _createBlock(_component_Message, {
                  key: 0,
                  size: "small",
                  severity: "secondary",
                  variant: "simple",
                  class: "text-red-700! ml-2 mt-0.5",
                  pt: { text: 'text-[11px]!' }
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.form.phone.msgErr), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true)
          ]),
          (_ctx.requireBank)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_component_IftaLabel, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_Select, {
                      modelValue: _ctx.form.bankName.value,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.form.bankName.value) = $event)),
                      inputId: "bank_name",
                      options: _ctx.banks,
                      "option-label": "name.th",
                      "option-value": "shortName",
                      class: "text-start w-full text-white! bg-[url('https://rpg168-storage.sgp1.cdn.digitaloceanspaces.com/theme/bg-input-1.webp')]! bg-size-[100%_100%]! bg-transparent! border-0!",
                      pt: { overlay: 'z-[9999]!' }
                    }, null, 8 /* PROPS */, ["modelValue", "options"]),
                    _cache[15] || (_cache[15] = _createElementVNode("label", {
                      for: "bank_name",
                      class: "text-white! text-[0.8rem]! font-semibold!"
                    }, "ธนาคาร", -1 /* HOISTED */))
                  ]),
                  _: 1 /* STABLE */,
                  __: [15]
                }),
                (_ctx.form.bankName.invalid)
                  ? (_openBlock(), _createBlock(_component_Message, {
                      key: 0,
                      size: "small",
                      severity: "secondary",
                      variant: "simple",
                      class: "text-red-700! ml-2 mt-0.5",
                      pt: { text: 'text-[11px]!' }
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.form.bankName.msgErr), 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    }))
                  : _createCommentVNode("v-if", true)
              ]))
            : _createCommentVNode("v-if", true),
          (_ctx.requireBank)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(_component_IftaLabel, null, {
                  default: _withCtx(() => [
                    _withDirectives(_createVNode(_component_InputText, {
                      id: "bank_number",
                      modelValue: _ctx.form.bankNumber.value,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((_ctx.form.bankNumber.value) = $event)),
                      onKeyup: _ctx.checkBankNumber,
                      minlength: "10",
                      maxlength: "14",
                      invalid: _ctx.form.bankNumber.invalid,
                      pattern: "^[0-9]{10,15}$",
                      class: "w-full text-white! bg-[url('https://rpg168-storage.sgp1.cdn.digitaloceanspaces.com/theme/bg-input-1.webp')]! bg-size-[100%_100%]! bg-transparent! border-0!",
                      autofocus: "",
                      "aria-autocomplete": "none"
                    }, null, 8 /* PROPS */, ["modelValue", "onKeyup", "invalid"]), [
                      [
                        _directive_keyfilter,
                        void 0,
                        void 0,
                        { num: true }
                      ]
                    ]),
                    _cache[16] || (_cache[16] = _createElementVNode("label", {
                      for: "bank_number",
                      class: "text-white! text-[0.8rem]! font-semibold!"
                    }, "เลขบัญชี", -1 /* HOISTED */))
                  ]),
                  _: 1 /* STABLE */,
                  __: [16]
                }),
                (_ctx.form.bankNumber.invalid)
                  ? (_openBlock(), _createBlock(_component_Message, {
                      key: 0,
                      size: "small",
                      severity: "secondary",
                      variant: "simple",
                      class: "text-red-700! ml-2 mt-0.5",
                      pt: { text: 'text-[11px]!' }
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.form.bankNumber.msgErr), 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    }))
                  : _createCommentVNode("v-if", true)
              ]))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_IftaLabel, null, {
              default: _withCtx(() => [
                _createVNode(_component_Select, {
                  modelValue: _ctx.form.recommend.value,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ((_ctx.form.recommend.value) = $event)),
                  inputId: "register_recommend",
                  options: _ctx.recommends,
                  "option-label": "name",
                  "option-value": "value",
                  class: "text-start w-full text-white! bg-[url('https://rpg168-storage.sgp1.cdn.digitaloceanspaces.com/theme/bg-input-1.webp')]! bg-size-[100%_100%]! bg-transparent! border-0!",
                  pt: { overlay: 'z-[9999]!' },
                  disabled: _ctx.hasRefId
                }, null, 8 /* PROPS */, ["modelValue", "options", "disabled"]),
                _cache[17] || (_cache[17] = _createElementVNode("label", {
                  for: "register_recommend",
                  class: "text-white! text-[0.8rem]! font-semibold!"
                }, "รู้จักเราผ่านช่องทางใด", -1 /* HOISTED */))
              ]),
              _: 1 /* STABLE */,
              __: [17]
            }),
            (_ctx.form.recommend.invalid)
              ? (_openBlock(), _createBlock(_component_Message, {
                  key: 0,
                  size: "small",
                  severity: "secondary",
                  variant: "simple",
                  class: "text-red-700! ml-2 mt-0.5",
                  pt: { text: 'text-[11px]!' }
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.form.recommend.msgErr), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true)
          ]),
          (_ctx.modeResolved)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                (_ctx.form.mode === 1)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _cache[18] || (_cache[18] = _createElementVNode("h5", { class: "text-md md:text-lg font-bold text-amber-100" }, "OTP", -1 /* HOISTED */)),
                      _createElementVNode("div", _hoisted_10, [
                        _createVNode(_component_InputOtp, {
                          modelValue: _ctx.form.otp.code,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => ((_ctx.form.otp.code) = $event)),
                          name: "passcode-otp",
                          length: 6,
                          integerOnly: ""
                        }, null, 8 /* PROPS */, ["modelValue"])
                      ]),
                      _createVNode(_component_Button, {
                        onClick: _ctx.handleOTP,
                        type: "button",
                        severity: "secondary",
                        label: "ส่ง sms เพื่อรับ OTP",
                        size: "small",
                        class: "mt-3"
                      }, null, 8 /* PROPS */, ["onClick"])
                    ], 64 /* STABLE_FRAGMENT */))
                  : (_ctx.form.mode === 2)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _cache[20] || (_cache[20] = _createElementVNode("h5", { class: "text-md md:text-lg font-bold text-amber-100" }, "CAPTCHA", -1 /* HOISTED */)),
                        _createElementVNode("div", _hoisted_11, [
                          (_ctx.form.captcha.image)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: _ctx.form.captcha.image,
                                alt: "Captcha Code",
                                class: "static w-full h-full bg-white"
                              }, null, 8 /* PROPS */, _hoisted_12))
                            : (_openBlock(), _createBlock(_component_ProgressSpinner, {
                                key: 1,
                                style: {"width":"30px","height":"30px"},
                                strokeWidth: "4",
                                fill: "transparent",
                                animationDuration: ".5s",
                                "aria-label": "Custom ProgressSpinner"
                              })),
                          _createVNode(_component_Button, {
                            onClick: _ctx.clickRefreshCaptcha,
                            class: "absolute! bottom-0 right-0 z-10 w-max! text-white px-1! py-0.5! rounded-tr-none! rounded-bl-none!",
                            size: "small",
                            loading: _ctx.form.captcha.image === ''
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(), _createElementBlock("svg", {
                                class: _normalizeClass(["size-4", { 'animate-spin': _ctx.form.captcha.image === '' }]),
                                "aria-hidden": "true",
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "24",
                                height: "24",
                                fill: "none",
                                viewBox: "0 0 24 24"
                              }, _cache[19] || (_cache[19] = [
                                _createElementVNode("path", {
                                  stroke: "currentColor",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2",
                                  d: "M17.651 7.65a7.131 7.131 0 0 0-12.68 3.15M18.001 4v4h-4m-7.652 8.35a7.13 7.13 0 0 0 12.68-3.15M6 20v-4h4"
                                }, null, -1 /* HOISTED */)
                              ]), 2 /* CLASS */))
                            ]),
                            _: 1 /* STABLE */
                          }, 8 /* PROPS */, ["onClick", "loading"])
                        ]),
                        _createElementVNode("div", _hoisted_13, [
                          _createVNode(_component_InputOtp, {
                            modelValue: _ctx.form.captcha.code,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => ((_ctx.form.captcha.code) = $event)),
                            name: "passcode",
                            integerOnly: ""
                          }, null, 8 /* PROPS */, ["modelValue"])
                        ])
                      ], 64 /* STABLE_FRAGMENT */))
                    : _createCommentVNode("v-if", true)
              ]))
            : _createCommentVNode("v-if", true),
          _createVNode(_component_Divider, {
            align: "center",
            type: "dotted"
          }, {
            default: _withCtx(() => _cache[21] || (_cache[21] = [
              _createElementVNode("span", { class: "text-xs font-bold" }, "เงื่อนไขการสมัคร", -1 /* HOISTED */)
            ])),
            _: 1 /* STABLE */,
            __: [21]
          }),
          _cache[22] || (_cache[22] = _createElementVNode("p", { class: "text-[10px]! text-amber-100 text-center w-2/3 mx-auto" }, " ชื่อ-นามสกุล จะต้องตรงกับชื่อบัญชีธนาคารที่ใช้ในการ ฝาก-ถอน เงินเท่านั้น ถ้าไม่ตรง งดถอนทุกกรณี ", -1 /* HOISTED */)),
          _createVNode(_component_Button, {
            label: "สมัคร",
            type: "submit",
            class: "min-w-20 mt-6 bg-[url('https://rpg168-storage.sgp1.cdn.digitaloceanspaces.com/theme/btn-ma.webp')]! bg-size-[100%_100%]! bg-transparent! border-transparent!",
            loading: _ctx.form.btn.loading,
            disabled: !_ctx.btnSubmitDisabled
          }, null, 8 /* PROPS */, ["loading", "disabled"])
        ], 32 /* NEED_HYDRATION */)),
    _createVNode(_component_Toast)
  ]))
}